import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";
const overviewImg = require("../../../Assets/Images/Overview.png");
const LatoRegular = require("../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    borderRadius: "5px",
    display: "flex",
    fontFamily: "Lato",
    backgroundColor: "#ffffff",
  },
  coverTitle: {
    marginBottom: "20px",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
  },
  secondsection: {
    marginTop: "5px",
    marginBottom: "5px",
    alignItems: "flex-start",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#426B88",
    fontFamily: "Lato",
  },
  subtitle: {
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#426B88",
    alignSelf: "flex-start",
    justifyContent: "flex-start",
    display: "flex",
  },
  paragraph: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    gap: "7px",
  },
  coverImage: {
    width: "100%",
    maxWidth: "400px",
    marginTop: "20px",
    marginLeft: "0px",
  },
  detailSection: {
    width: "200px",
    height: "170px",
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Lato",
  },
  detailTitle: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#245775",
    fontFamily: "Lato",
  },
  detailSubtitle: {
    marginTop: "10px",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "18px",
    color: "#245775",
    fontFamily: "Lato",
  },
  author: {
    marginTop: "30px",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "17px",
    color: "#245775",
    fontFamily: "Lato",
  },
  section: {
    textAlign: "left",
    maxWidth: "800px",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#245775",
    textAlign: "left",
    marginTop: "20px",
    fontFamily: "Lato",
  },
  image: {
    width: "100%",
    maxWidth: "400px",
    marginTop: "20px",
    alignSelf: "flex-start",
  },
  secondBox: {
    gap: "10px",
  },
  mainTitle: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#245775",
    textAlign: "left",
    marginTop: "20px",
    fontFamily: "Lato",
    lineHeight: "18px",
  },
  pointBox: {
    marginBottom: "10px",
    marginTop: "10px",
  },
});

const Overview = ({ apiData }) => {
  return (
    <View style={styles.coverSection}>
    <View>
      <Text style={styles.coverTitle}>OVERVIEW</Text>
      <View style={styles.secondBox}>
        <Text style={styles.paragraph}>
          Dr. Rob Murray and Jack Nicholson developed a transformative leadership model called the Human Operating System™ (HOS) to help leaders, teams, and organizations recover the heart, soul, mind, and strength of their life and leadership. Quadrant Flow™ is a valid and reliable psychometric assessment built on the five principles and foundation of the HOS.
        </Text>
        <Text style={styles.paragraph}>
          Designed for businesses, leaders, coaches, consultants, churches, and nonprofits, this framework helps individuals and teams unlock bold, sustainable levels of alignment, growth, and impact. Unlike static personality models, Quadrant Flow™ is about movement—learning to navigate and flow through the four quadrants of HEART, SOUL, MIND, and STRENGTH™ in real time. These quadrants are more than traits—they're dimensions of what it means to be fully human, and learning to move between them is what fuels transformation.
        </Text>
        <Text style={styles.paragraph}>
          Discover your greatest potential and contribution. Understand yourself and others more deeply.
        </Text>
      </View>
    </View>
    <View style={styles.secondsection}>
      <Text style={styles.subtitle}>WHAT DOES QUADRANT FLOW MEASURE?</Text>
    </View>
  
    <View style={styles.section}>
      <Text style={styles.paragraph}>
        Built on the Human Operating System™ (HOS) framework, the Quadrant Flow™ assessment uses 82 questions and a 5-point scale to measure the integrative power of your life and leadership across four key dimensions:
      </Text>
      <View style={styles.pointBox}>
        <Text style={styles.paragraph}>
          <Text style={styles.mainTitle}>1. HOME: </Text>
          Identifies your Starter Quadrant: Heart, Soul, Mind, or Strength. This is your natural starting point for action, decision-making, and presence—shaped by a mix of nature, nurture, and life experience.
        </Text>
        <Text style={styles.paragraph}>
          <Text style={styles.mainTitle}>2. FLOW: </Text>
          Assesses your Flow Type™, the order in which you move through the remaining quadrants. Your first shift after your Starter is often the strongest, revealing how you instinctively respond. From there, one of 24 unique flow patterns unfolds, showing how you adapt, lead, and move in real time.
        </Text>
        <Text style={styles.paragraph}>
          <Text style={styles.mainTitle}>3. LEAD: </Text>
          Maps your leadership style—Strategic, Performance, Collaborative, or Visionary—using a validated framework built on the quadrant system. It also provides a GAP analysis between your Starter Quadrant and current leadership expression, highlighting areas of alignment and growth.
        </Text>
        <Text style={styles.paragraph}>
          <Text style={styles.mainTitle}>4. GROW: </Text>
          Evaluates your mindset across a spectrum—from more fixed to more growth-oriented. This reveals how you approach challenge, feedback, and the ongoing invitation to grow.
        </Text>
      </View>
      <Text style={styles.paragraph}>
        This tool offers leaders and teams grounded, actionable insight into how they show up, lead, and grow—unlocking greater alignment, impact, and contribution.
      </Text>
    </View>
    <View style={{ alignItems: "flex-start", width: "100%" }}>
      <Image src={overviewImg} style={styles.image} />
    </View>
  </View>  
  );
};

export default Overview;
